import { makeStyles, Theme } from '@material-ui/core'

import { ListProps } from './ListProps'

export const useStyles = makeStyles<Theme, ListProps>((theme) => ({
  root: {
    '&$uncontained > li > *:first-child': {
      background: theme.palette.background.paper,
      borderRadius: theme.spacing(1),
    },
    '& > li > *:first-child': {
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    '& > li:last-child > *:first-child': {
      borderBottom: 'none',
    },
  },
  uncontained: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}))
